import { render, staticRenderFns } from "./IncomeExpenseReviewReport.vue?vue&type=template&id=639e130a"
import script from "./IncomeExpenseReviewReport.vue?vue&type=script&lang=js"
export * from "./IncomeExpenseReviewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports